import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {UsersPage} from "../pages/user/UsersPage";
import {SAOrgsPage} from "../pages/super-admin/orgs/SAOrgsPage";
import {SABillingPage} from "../pages/super-admin/billing/SABillingPage";
import {SAPaymentHistoryPage} from "../pages/super-admin/billing/SAPaymentHistoryPage";
import {SAMonthlyOverviewPage} from "../pages/super-admin/billing/SAMonthlyOverviewPage";
import {SADashboardPage} from "../pages/super-admin/dashboard/SADashboardPage";
import {PermissionsPage} from "../pages/roles-permissions/PermissionsPage";
import {RolesPage} from "../pages/roles-permissions/RolesPage";
import {DesignationsPage} from "../pages/designations/DesignationsPage";
import {WorkersPage} from "../pages/workers/WorkersPage";
import {AdvisorsPage} from "../pages/advisors/AdvisorsPage";
import {DealersPage} from "../pages/dealers/DealersPage";
import {BranchesPage} from "../pages/branches/BranchesPage";
import {VehicleModelsPage} from "../pages/vehicleModels/VehicleModelsPage";
import {TreatmentsPage} from "../pages/treatments/TreatmentsPage";
import {WaterWashPage} from "../pages/waterWash/WaterWashPage";
import {WaterWashBranchPage} from "../pages/waterWash/WaterWashBranchPage";
import {AttendanceBranchesPage} from "../pages/attendance/AttendanceBranchesPage";
import {AttendanceWorkerPage} from "../pages/attendance/AttendanceWorkerPage";
import {MonthAttendanceView} from "../pages/attendance/MonthAttendanceView";
import AllReportsPage from '../pages/reports/AllReportsPage'
import TreatmentsByAdvisorPage from '../pages/reports/treatments-by-advisor/TreatmentsByAdvisorPage'
import TreatmentsBySupervisorPage from '../pages/reports/treatments-by-supervisor/TreatmentsBySupervisorPage'
import TreatmentsByBranchPage from '../pages/reports/treatments-by-branch/TreatmentsByBranchPage'
import TreatmentsByDealerPage from '../pages/reports/treatments-by-dealer/TreatmentsByDealerPage'
import MostUsedTreatmentsPage from '../pages/reports/most-used-treatments/MostUsedTreatmentsPage'
import TreatmentCategoryAnalysisPage from '../pages/reports/treatment-category-analysis/TreatmentCategoryAnalysisPage'
import JobCardSummaryPage from '../pages/reports/job-cards-summary/JobCardSummaryPage'
import AdvisorPerformancePage from '../pages/reports/advisor-performance/AdvisorPerformancePage'
import RevenueAnalysisPage from '../pages/reports/revenue-analysis/RevenueAnalysisPage'
import VehicleSegmentAnalysisPage from '../pages/reports/vehicle-segment-analysis/VehicleSegmentAnalysisPage'
import DeletedTreatmentsPage from '../pages/reports/deleted-treatments/DeletedTreatmentsPage'
import DailyJobCardVolumePage from '../pages/reports/daily-job-card-volume/DailyJobCardVolumePage'
import WaterWashAnalysisPage from '../pages/reports/water-wash-analysis/WaterWashAnalysisPage'
import VehicleModelPage from '../pages/reports/vehicle-model/VehicleModelPage'
import WaterWashListPage from '../pages/reports/water-wash-list/WaterWashListPage'
import TreatmentBillingPage from '../pages/reports/treatment-billing/TreatmentBillingPage'
import TreatmentMonthlyViewDPPage from '../pages/reports/treatment-monthly-view-dp/TreatmentMonthlyViewDPPage'
import TreatmentMonthlyViewCPPage from '../pages/reports/treatment-monthly-view-cp/TreatmentMonthlyViewCPPage'
import {AuditsPage} from "../pages/audit-history/AuditsPage";
import {ActiveJobsPage} from "../pages/activeJobs/ActiveJobsPage";
import {JobCardsPage} from "../pages/jobCards/JobCardsPage";
import {JobCardListPage} from "../pages/jobCards/JobCardListPage";
import {JobSearchPage} from "../pages/jobCards/JobSearchPage";
import {useAuth} from "../modules/auth";
import {isSuperAdmin} from "../utils/Utils";
import React from "react";

const PrivateRoutes = () => {
    const {currentUser} = useAuth();

    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                    {/* Redirect to Dashboard after success login/registartion */}

                    {isSuperAdmin(currentUser) === false &&
                    <Route path='auth/*' element={<Navigate to='/dashboard'/>}/>
                    }

                    {isSuperAdmin(currentUser) &&
                    <Route path='auth/*' element={<Navigate to='/sadashboard'/>}/>
                    }

                    {/* Dashboard */}
                    <Route path='dashboard' element={<DashboardWrapper/>}/>

                    <Route path='users' element={<UsersPage/>}/>
                    <Route path='designations' element={<DesignationsPage/>}/>
                    <Route path='workers' element={<WorkersPage/>}/>
                    <Route path='advisors' element={<AdvisorsPage/>}/>
                    <Route path='dealers' element={<DealersPage/>}/>
                    <Route path='branches' element={<BranchesPage/>}/>
                    <Route path='vehicleModels' element={<VehicleModelsPage/>}/>
                    <Route path='treatments' element={<TreatmentsPage/>}/>
                    <Route path='waterWash' element={<WaterWashPage/>}/>
                    <Route path='waterWash/branch/:branchId' element={<WaterWashBranchPage/>}/>
                    <Route path='activeJobs' element={<ActiveJobsPage/>}/>
                    <Route path='jobCards' element={<JobCardsPage/>}/>
                    <Route path='jobCards/branch/:branchId' element={<JobCardListPage/>}/>
                    <Route path='job-search' element={<JobSearchPage/>}/>
                    <Route path='attendance/branches' element={<AttendanceBranchesPage/>}/>
                    <Route path='attendance/workers/:branchId' element={<AttendanceWorkerPage/>}/>
                    <Route path='attendance/month-view' element={<MonthAttendanceView/>}/>
                    <Route path='reports' element={<AllReportsPage/>}/>
                    <Route path='reports/treatments-by-advisor' element={<TreatmentsByAdvisorPage/>}/>
                    <Route path='reports/treatments-by-supervisor' element={<TreatmentsBySupervisorPage/>}/>
                    <Route path='reports/treatments-by-branch' element={<TreatmentsByBranchPage/>}/>
                    <Route path='reports/treatments-by-dealer' element={<TreatmentsByDealerPage/>}/>
                    <Route path='reports/most-used-treatments' element={<MostUsedTreatmentsPage/>}/>
                    <Route path='reports/treatment-category-analysis' element={<TreatmentCategoryAnalysisPage/>}/>
                    <Route path='reports/job-card-summary' element={<JobCardSummaryPage/>}/>
                    <Route path='reports/advisor-performance' element={<AdvisorPerformancePage/>}/>
                    <Route path='reports/revenue-analysis' element={<RevenueAnalysisPage/>}/>
                    <Route path='reports/vehicle-segment-analysis' element={<VehicleSegmentAnalysisPage/>}/>
                    <Route path='reports/deleted-treatments' element={<DeletedTreatmentsPage/>}/>
                    <Route path='reports/daily-job-card-volume' element={<DailyJobCardVolumePage/>}/>
                    <Route path='reports/water-wash-analysis' element={<WaterWashAnalysisPage/>}/>
                    <Route path='reports/vehicle-model' element={<VehicleModelPage/>}/>
                    <Route path='reports/water-wash-list' element={<WaterWashListPage/>}/>
                    <Route path='reports/treatment-billing' element={<TreatmentBillingPage/>}/>
                    <Route path='reports/treatment-monthly-view-dp' element={<TreatmentMonthlyViewDPPage/>}/>
                    <Route path='reports/treatment-monthly-view-cp' element={<TreatmentMonthlyViewCPPage/>}/>
                    <Route path='roles' element={<RolesPage/>}/>
                    <Route path='permissions' element={<PermissionsPage/>}/>
                    <Route path='auditLogs' element={<AuditsPage/>}/>

                    {/*Super Admin*/}
                    <Route path='organizations' element={<SAOrgsPage/>}/>
                    <Route path='super-admin/billing/config' element={<SABillingPage/>}/>
                    <Route path='super-admin/billing/monthly' element={<SAMonthlyOverviewPage/>}/>
                    <Route path='super-admin/billing/:orgId/payments' element={<SAPaymentHistoryPage/>}/>
                    <Route path='sadashboard' element={<SADashboardPage/>}/>

                    <Route path='*' element={<Navigate to='/error/404'/>}/>
                </Route>
            </Routes>
    )
};

export {PrivateRoutes}